module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Dial-numbers-a106fd463a3ba0f1157e7f413a2fc5d8.svg";